const CALLBACK_PATH = "/m365-mail-callback";
const ADMIN_CONSENT_PATH = "/m365-admin-consent";
const RETURN_PATH_KEY = "m365MailboxReturnPath";

export interface AdminConsentOutcome {
	approved: boolean;
	errorDescription: string;
}

// Only ever navigate back to an in-app path we stored ourselves — never an absolute/protocol URL.
const sanitizeReturnPath = (value: string | null): string =>
	value && value.startsWith("/") && !value.startsWith("//") ? value : "/";

const m365Mailbox = {
	// Microsoft can send admin_consent=True alongside an error, so the error wins.
	adminConsentOutcome: (params: URLSearchParams): AdminConsentOutcome => {
		const error = params.get("error");
		if (error) return { approved: false, errorDescription: params.get("error_description") || error };
		return { approved: params.get("admin_consent")?.toLowerCase() === "true", errorDescription: "" };
	},
	adminConsentRedirectUri: (): string => `${window.location.origin}${ADMIN_CONSENT_PATH}`,
	callbackPath: CALLBACK_PATH,
	redirectUri: (): string => `${window.location.origin}${CALLBACK_PATH}`,
	readReturnPath: (): string => {
		const stored = window.sessionStorage.getItem(RETURN_PATH_KEY);
		window.sessionStorage.removeItem(RETURN_PATH_KEY);
		return sanitizeReturnPath(stored);
	},
	rememberReturnPath: (): void => {
		window.sessionStorage.setItem(RETURN_PATH_KEY, window.location.pathname + window.location.search);
	}
};

export default m365Mailbox;
